"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils");
var _Carousel = _interopRequireDefault(require("../Carousel"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @deprecated Please use Carousel and pass the `tabs` prop.
 */const CarouselTabs = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    items,
    refocus = true,
    ...carouselProps
  } = _ref;
  const tabs = (0, _utils.useResponsiveProp)({
    md: items
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Carousel.default, {
    refocus: refocus,
    ...carouselProps,
    ref: ref,
    tabs: tabs,
    children: items.map(_ref2 => {
      let {
        title,
        content
      } = _ref2;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.default.Fragment, {
        children: content
      }, title);
    })
  });
});
CarouselTabs.displayName = 'CarouselTabs';
CarouselTabs.propTypes = {
  /**
   * An array of objects where title is the string shown in the slide's tab and content is the JSX for the slide itself
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired,
    content: _propTypes.default.node.isRequired
  })),
  ..._Carousel.default.propTypes
};
// CarouselTabs doesn't require `children` prop, it uses `items` instead.
// eslint-disable-next-line react/forbid-foreign-prop-types
if (CarouselTabs.propTypes?.children) delete CarouselTabs.propTypes?.children;
var _default = exports.default = CarouselTabs;